export const chartOptions = {options: {
    chart: {
        type: 'line',
        height: 450,
        zoom: {
            type: 'xy',
            enabled: true,
            autoScaleYaxis: true,
            allowMouseWheelZoom: false,  

        },
        toolbar: {
            autoSelected: 'zoom',
            tools: {
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true,
            },
        },
    },
    stroke: {
        curve: 'stepline',
        width: 2
    },
    /* fill: {
        type: 'gradient',
        gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 0.8,
            stops: [0, 90, 100]
        },
    }, */
    title: {
        text: 'Time Series Data',
        align: 'left'
    },
    xaxis: {
        type: 'datetime',
        labels: {
            datetimeUTC: false,
            format: 'dd/MM/yyyy HH:mm',
            rotate: -45,  // Add this line to rotate labels

        },

    },
    tooltip: {
        enabled: true,
        followCursor: true,    // Disable follow cursor
        intersect: false,       // Show tooltip even when not directly over point
        shared: true,           // Show all series in tooltip
        custom: undefined,      // Remove any custom tooltip
        fixed: {
            enabled: true,      // Enable fixed position
            position: 'topRight', // Position the tooltip
            offsetX: 10,        // Add some horizontal offset
            offsetY: 10,        // Add some vertical offset
        },
        x: {
            format: 'dd MMM yyyy HH:mm'
        },
        marker: {
            show: true,
        },
        onDatasetHover: {
            highlightDataSeries: true,
        },
    },
    yaxis: {
        title: {
            text: 'Value'
        }
    },
    legend: {
        position: 'top'
    },
    
    grid: {
            borderColor: '#f1f1f1'
        }
    }
}
